module.exports = __webpack_public_path__ + "media/images/wallet/payment4-237b85b7ae6c010a23fac374f06472c7.svg";